import { useState, useEffect } from "react";
import { Box, Tooltip } from "@mui/material";
import { getAbilityIconUrl, getAbilityIconUrlFallback } from "./levelStatsUtils";

/**
 * Zeigt das offizielle Splinterlands-Icon einer Fähigkeit. Splinterlands pflegt zwei
 * Icon-Ordner (ältere Fähigkeiten unter "small", neuere direkt darüber) - erst die
 * "small"-URL versuchen, bei 403/404 die zweite versuchen, erst danach auf ein
 * Text-Badge zurückfallen.
 */
const AbilityBadge = ({ ability, dimmed = false, size = 22 }) => {
  const [stage, setStage] = useState(0); // 0 = primary icon, 1 = fallback icon, 2 = text badge

  useEffect(() => {
    setStage(0);
  }, [ability]);

  const primaryUrl = getAbilityIconUrl(ability);
  const fallbackUrl = getAbilityIconUrlFallback(ability);
  const iconUrl = stage === 0 ? primaryUrl : fallbackUrl;

  if (stage === 2 || !iconUrl) {
    return (
      <Tooltip title={ability}>
        <Box
          sx={{
            fontSize: '10px',
            fontWeight: 'bold',
            color: 'white',
            bgcolor: 'grey.700',
            borderRadius: '4px',
            px: 0.5,
            py: 0.25,
            opacity: dimmed ? 0.5 : 1,
            whiteSpace: 'nowrap'
          }}
        >
          {ability}
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={ability}>
      <Box
        component="img"
        src={iconUrl}
        alt={ability}
        onError={() => setStage(prev => prev + 1)}
        sx={{ width: size, height: size, opacity: dimmed ? 0.5 : 1 }}
      />
    </Tooltip>
  );
};

export default AbilityBadge;
